import * as React from "react"
import { clx } from "../utils/clx"

/**
 * This component is based on the `kbd` element and supports all of its props
 */
const Kbd = React.forwardRef<
  HTMLElement,
  React.ComponentPropsWithoutRef<"kbd">
>(({ children, className, ...props }, ref) => {
  return (
    <kbd
      {...props}
      ref={ref}
      className={clx(
        "bg-grey-20 text-ui-fg-subtle border-ui-border-strong inline-flex h-5 w-fit min-w-[20px] items-center justify-center rounded-md border px-1",
        "txt-compact-small-plus",
        className
      )}
    >
      {children}
    </kbd>
  )
})
Kbd.displayName = "Kbd"

export { Kbd }
